import {
	Component,
	EventEmitter,
	Input,
	OnChanges,
	Output,
	SimpleChanges,
} from '@angular/core';
import { ProfessionalService } from 'app/services/professional.service';
import dayjs from 'dayjs';

@Component({
	selector: 'appointments-no-show-select',
	templateUrl: './appointments-no-show-select.component.html',
	styleUrls: ['./appointments-no-show-select.component.scss'],
})
export class AppointmentsNoShowSelectComponent implements OnChanges {
	@Input() disabled: boolean;
	@Input() contactId: string;
	@Input() invalid = false;
	@Output() onOptionChange = new EventEmitter();
	value: string = null;
	options = [];

	constructor(private readonly professionalService: ProfessionalService) {}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes.contactId) {
			this.loadAppointmentsNoShow();
		}
	}

	loadAppointmentsNoShow() {
		if (!this.contactId) return;
		this.professionalService
			.loadAppointmentsNoShow(this.contactId)
			.subscribe((response) => {
				this.options = response.map((item) => ({
					label: `${item.customerName}, ${dayjs(item.day).format(
						'DD/MM/YYYY [às] HH[h]mm'
					)}`,
					value: item.id,
				}));
			});
	}

	selectAppointment(selectedItem: string) {
		this.onOptionChange.emit(selectedItem);
	}
}
